var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-sy",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v320H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h640v160H0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "m161 300 39-120 39 120-102-74.2h126M401 300l39-120 39 120-102-74.2h126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSy);
export default __webpack_public_path__ + "static/media/sy.a7d9792964e74fe3a58f7feb4ccff29e.svg";
export { ForwardRef as ReactComponent };